module.exports = san.defineComponent({
    template: require('../views/evaluateAlert.html'),
    initData: function() {
        return {
            showTip: false,
            touch: false,
            type: 'qjzx',
            showTipMsg: '',
            evaluateContent: '',
            uselessType: 0
        };
    },
    components: {

    },
    switchType: function(t) {
        this.data.set('uselessType',t);
    },
    close: function() {
        this.dispatch("cancel");
    },
    sure: function() {
        if(this.data.get('uselessType')==0){
            this.countTime('请您选择一条评价');
            return;
        }
        if(this.data.get('type') == 'znzx' && this.data.get('uselessType')==4 && this.data.get('evaluateContent')==''){
            this.countTime('请您具体描述');
            return;
        }
        if(this.data.get('type') == 'qjzx' && this.data.get('uselessType')==5 && this.data.get('evaluateContent')==''){
            this.countTime('请您具体描述');
            return;
        }
        var contData = {
            "evaluateState": 2,
            "uselessType": this.data.get('uselessType'),
            "evaluateContent": this.data.get('evaluateContent')
        };
        this.dispatch("sureBtn",contData);
    },
    countTime: function(showTipMsg){
        var showNum = 3, me = this;
        this.data.set('showTipMsg',showTipMsg);
        this.data.set('showTip',true);
        var t=setInterval(
            function(){
                showNum--;
                if(showNum<=0){
                    me.data.set('showTip',false);
                    clearInterval(t);
                }
            },1000);
    },
});


//////////////////
// WEBPACK FOOTER
// ./src/components/evaluateAlert.js
// module id = 364
// module chunks = 1